import {NgModule} from '@angular/core';
import {EntityDataService, EntityServices} from '@ngrx/data';
import {PaymentRequestDataService} from './impl/service/ngrx/paymentRequestData.service';
import {PaymentRequestConfigurationModule} from './configuration/paymentRequestConfiguration.module';
import {PaymentRequestReminderModule} from './reminder/paymentRequestReminder.module';
import {PaymentRequestRepository} from './impl/service/ngrx/PaymentRequest.repository';
import {PaymentRequestMovementModule} from "./movement/paymentRequestMovement.module";
import {PaymentRequestOnlineAttemptModule} from "./payment_request_online_attempt/paymentRequestOnlineAttempt.module";
import {errorMessages} from "../../../core/error/errorMessages";
@NgModule({
    imports: [
        PaymentRequestConfigurationModule,
        PaymentRequestReminderModule,
        PaymentRequestMovementModule,
        PaymentRequestOnlineAttemptModule,
    ],
})
export class PaymentRequestModule {
    constructor(entityDataService: EntityDataService,
                entityServices: EntityServices,
                service: PaymentRequestRepository,
                dataService: PaymentRequestDataService,
    ) {

        entityDataService.registerServices({
            PaymentRequest: dataService,
        });

        entityServices.registerEntityCollectionServices({
            PaymentRequest: service,
        });
        errorMessages.set('PAYMENT_REQUEST_ADD_MOVEMENT_MULTIPLE_WRONG_SUM', 'Le montant du mouvement et des demandes de paiement ne correspondent pas.')
        errorMessages.set('PAYMENT_REQUEST_REMOVE_MOVEMENT_NOT_ALLOWED', 'Le paiement ne peut pas être supprimé car il a été effectué avec le lecteur de carte PodoPro.');
        errorMessages.set('PAYMENT_REQUEST_GROUP_NO_CHILDREN', 'Aucune demande de paiement n\a été trouvée.');
        errorMessages.set('PAYMENT_REQUEST_IN_GROUP_NO_DELETABLE', 'La demande de paiement ne peut être supprimée car elle fait partie d\'une demande de paiement groupée.');
        errorMessages.set('PAYMENT_REQUEST_NOT_DELETABLE', 'La demande de paiement n\'est pas supprimable.');
        errorMessages.set('PAYMENT_REQUEST_IN_GROUP_NO_DELETABLE', 'Les demandes de paiement qui ont été groupés ne sont pas supprimables')

    }
}
